import axios from "axios";
import config from "@/config";
import { requestInterceptor, responseInterceptor } from "./identity.interceptors";

/**
 * Identity server instance
 */
const $identity = axios.create({
  baseURL: config.MAROPOST_IDENTITY_BASE_URL
});

/**
 * Intercept all requests sent to Identity
 */
$identity.interceptors.request.use(requestInterceptor);

$identity.interceptors.response.use(null,responseInterceptor);

export default $identity;
